<template>
    <div>
        <compra-direta-ferramenta-de-busca v-model="filtrosBuscaAvancada"
                                           :situacoesPossiveis="situacoesCompraDireta"
                                           :placeholderPesquisa="placeholderPesquisa"
                                           :filtros="filtrosInterno"
                                           :filtro-completo="false"
                                           @eventoBuscaSimples="tratarEventoBuscaSimples"
                                           @eventoRemoverFiltro="tratarEventoRemoverFiltro">
        </compra-direta-ferramenta-de-busca>

        <listagem-compra-direta-legada :itens="itens"
                                               :paginas="paginas"
                                               :total-itens="totalItens"
                                               v-model="paginacao"
                                               :textoVazio="'Não há compras diretas em andamento'"
                                               @acessar="tratarEventoAcessar"
                                                @paginar="tratarEventoPaginar"/>
    </div>
</template>

<script>
import _ from 'lodash'
import {actionTypes, mutationTypes} from '@/core/constants'
import CompraDiretaFerramentaDeBusca from '@/views/pages/commons/busca-avancada/CompraDiretaFerramentaDeBusca'
import ListagemCompraDiretaLegada from '@/views/pages/comprador/legado/components/ListagemCompraDiretaLegada.vue'

export default {
    name: 'ComprasDiretasLegadas',
    components: {
        CompraDiretaFerramentaDeBusca,
        ListagemCompraDiretaLegada
    },
    data() {
        return {
            itens: [],
            paginas: 0,
            totalItens: 0,
            ehBuscaAvancada: false,
            filtrosInterno: this.getFiltrosComprasLegadas(),
            filtrosBuscaAvancada:{},
            paginacao: this.$store.state.comprador.resultadoBuscaComprasLegadas.paginacao
        }
    },
    mounted() {
        this.atualizarFiltro()
        this.buscar()
    },
    computed: {
        placeholderPesquisa() {
            return 'Busque por: nº processo, nº consulta, objeto ou orgão'
        }
    },
    methods: {
        atualizarFiltro() {
            if(this.$route.query) {
                this.paginacao.page = this.$route.query.page || 1
                this.paginacao.rowsPerPage = this.$route.query.rowsPerPage || 10
            }
        },
        async buscar() {
            this.$store.commit(mutationTypes.COMPRADOR.SET_FILTROS_BUSCA_COMPRAS_LEGADAS, this.getFiltrosInterno())
            this.setMensagemLoading('Carregando compras diretas...')
            const resultado = await this.$store.dispatch(actionTypes.LEGADO.BUSCAR_LISTAGEM_PROCESSO)
            this.itens = [ ...resultado.compras ]
            this.paginas = resultado.totalPages
            this.totalItens = resultado.totalElements
        },
        tratarEventoAcessar(id) {
            const rota = {
                name: 'ComprasDiretasLegadas',
                query: { ...this.filtro }
            }
            this.$store.commit(mutationTypes.SET_ROTA_VOLTA, rota)
            this.$router.push({name: 'CompraDiretaLegadaDetalhesCapa', params: {id}})
        },
        tratarEventoBuscaSimples(valor) {
            if (valor) {
                this.filtrosInterno.objeto.value = valor
                this.filtrosInterno.conteudo = valor
                this.buscar()
            }
        },
        tratarEventoPaginar(paginacao) {
            this.buscar()
        },
        tratarEventoRemoverFiltro(propriedade) {
            if (this.filtrosInterno && this.filtrosInterno.hasOwnProperty(propriedade)) {
                this.filtrosInterno[propriedade].value = this.filtrosInterno[propriedade].default
            }
            this.filtrosInterno.conteudo = ''
            this.buscar()
        },
        getFiltrosComprasLegadas() {
            return _.cloneDeep(this.$store.state.comprador.resultadoBuscaComprasLegadas.filtros)
        },
        getFiltrosInterno() {
            return _.cloneDeep(this.filtrosInterno)
        },
    },
    watch: {
        paginacao: {
            handler(value){
                const rota = {
                    name: 'ComprasDiretasLegadas',
                    query: { ...this.paginacao }
                }
                this.$router.replace(rota)
            },
            deep:true,
            immediate: true
        }
    }
}
</script>

<style scoped>

</style>
